module.exports = __webpack_public_path__ + "images/entity-view-360-f08eb132.svg";